import React from 'react';
import { useTheme } from 'styled-components';
import Errorutline from 'images/error_outline.svg';

type InstrucaoBoletoPdfProps = {
    message?: string;
}

const InstrucaoBoletoPdf: React.FC<InstrucaoBoletoPdfProps> = ({message}) => {
    const theme: any = useTheme();
    
  return (
        <div style={{ display: 'flex', alignItems: 'center', 
            marginRight: 24, 
            marginLeft: 24 }}>
            <img src={Errorutline} alt="Atencão" style={{ width: 24, height: 24}}/> {" "}
            <p style={{ 
                fontWeight: 600, 
                fontSize: 14, 
                marginLeft: 8,
                color:  
                theme?.palette?.primary?.main 
            }}>
                {!!message && message}
            </p>
        </div>
    );
}

export default InstrucaoBoletoPdf;